module.exports = __webpack_public_path__ + "static/media/CloseOrder.05da5589.svg";